import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import "./Booklist.css";
// import BookButton from '../BookButton/BookButton';

const Book = (book) => {
  // const [bookStatus, setBookStatus] = useState({});

  // const toggleBookStatus = (book) => {
  //   setBookStatus(prevStatus => ({
  //     ...prevStatus,
  //     [book]: !prevStatus[book]
  //   }));
  // };
  const[visitedBook, setVisitedBook] = useState(false);
  //  const[visitedBook, setVisitedBook] = useState(null);

  const handleBookClick = () => {
    setVisitedBook(true);
  };
   
  // const isBookVisited = (book) => {
  //   return visitedBook.includes(book)
  // } 
  return (
    <div className="book-item flex flex-column flex-sb">
      <div className="book-item-img">
        <img src= {book.cover_img} alt='images'/>
      </div>
      
      <div className="book-item-info text-center">
        <Link to = {`/book/${book.id}`} {...book}>
          <div className="book-item-info-item title fs-18 fw-7">
            <span>{book.title}</span>
          </div>
        </Link>
        <div className="book-item-info-item author fs-15">
          <span className="text-capitalize fw-7">Author: </span>
          <span>{book.author}</span>
        </div>
        <div className="book-item-info-item edition-count fs-15">
          <span className="text-capitalize fw-7">Total Editions: </span>
          <span>{book.edition_count}</span>
        </div>
        <div className="book-item-info-item publish-year fs-15">
          <span className='text-capitalize fw-7'>First Publish Year: </span>
          <span>{book.first_publish_year}</span>
        </div>
        <div>
        <Link to = {book} onClick={handleBookClick} 
          style={{ color: visitedBook ? 'green' : 'blue', textDecoration: visitedBook ? 'none' : 'underline' }}>
           Read More
        </Link>
        {visitedBook && <p>You visited the book.</p>}
        </div>
             </div>
    </div>
  )
}

export default Book